import { useState } from 'react'
import { ErroreApi } from '../../servizi/api.ts'
import { Bottone } from '../../componenti/base.tsx'
import { IconaGraffetta } from '../../componenti/Icone.tsx'

/**
 * «Inoltra come allegato» accanto a «Inoltra» (539, come in Roundcube): il messaggio parte come file .eml
 * allegato, con le sue intestazioni e i suoi allegati controllati. Il file lo prepara l'API (pagina Posta,
 * inoltraComeAllegato); qui il comando, con l'attesa e l'errore.
 */
export function BottoneInoltraComeAllegato({ inoltra, discreto = false }: {
  inoltra: () => Promise<void>
  /** Fra i comandi di un messaggio, discreto come gli altri; nella conversazione, come «Inoltra». */
  discreto?: boolean
}) {
  const [inCorso, setInCorso] = useState(false)
  const [errore, setErrore] = useState<string | null>(null)

  async function premi() {
    setInCorso(true); setErrore(null)
    try {
      await inoltra()
    } catch (e) {
      setErrore(e instanceof ErroreApi ? e.message : 'Non è andata a buon fine: controlla la connessione e riprova.')
    } finally { setInCorso(false) }
  }

  return (
    <>
      <Bottone dimensione="piccolo" variante={discreto ? 'discreto' : 'secondario'} icona={<IconaGraffetta />}
               inCorso={inCorso} onClick={() => void premi()}
               title={discreto ? 'Inoltra questo messaggio come file .eml allegato' : 'Inoltra l’ultimo messaggio come file .eml allegato'}>
        Inoltra come allegato
      </Bottone>
      {errore && <span className="piccolo" role="alert">{errore}</span>}
    </>
  )
}
